import { defineMessages } from 'react-intl';

export default defineMessages({
  primaryModalButtonCancel: {
    defaultMessage: 'Cancel',
    description: 'Cancel button',
    id: 'primaryModal.button.cancel',
  },
});
